import { OrganizationUserDTO, StaticRole, UserOrganizationStatus, UserRole } from '@markant-platform/shared/user/model';
import { BehaviorSubject } from 'rxjs';
import { UsageRight, UsageRightPaymentModel, UsageRightState } from '@markant-platform/usage-right/model';
import { Page } from '@markant-platform/shared/data-access';
import { Group } from '@markant-platform/authorizer/model';
import { OrganizationDetailData, OrganizationType, QualificationLevel } from 'data-model';

export const MOCK_ORGANIZATION_DETAIL_DATA: OrganizationDetailData = {
  organizationId: '63a56f5a704b744a2995513a',
  name: 'Test GmbH',
  gln: '4260304620007',
  address: { street: 'street', city: 'Dortmund', streetNumber: '1', countryCode: 'DE', zipCode: '123214' },
  phone: '1231242',
  taxNumber: '123124',
  qualificationLevel: QualificationLevel.LEVEL_3,
  paymentInformation: {
    iban: 'DE89370400440532013000',
    bic: 'DEISKNJS',
    bank: 'Bank',
  },
  contact: 'Hans',
  contactMail: 'john.doe@example.markant.com',
  organizationType: OrganizationType.SUPPLIER,
  markantOrganization: false,
  ezrCustomer: false,
  version: 1,
  masterKin: 'master-kin-1234',
  furtherKins: ['123', '456'],
  crmId: 'crm-id-123',
};

export const organizationData = {
  ...MOCK_ORGANIZATION_DETAIL_DATA,
  address: {
    city: 'Teststadt',
    countryCode: 'DE',
    street: 'Teststr.',
    streetNumber: '1',
    zipCode: '01234',
  },
  billingEmail: 'billing@example.markant.com',
  billingLanguageIsoCode: '',
  commercialRegister: '',
  commercialRegisterId: 'HRA987654321',
  crmId: 'crm-id-123',
  furtherKins: ['123', '456'],
  gln: '4260304620007',
  industry: 'DEALER',
  markantId: '',
  markantOrganization: false,
  masterKin: 'master-kin-1234',
  naceCode: '123',
  name: 'Test GmbH',
  organizationType: 'DEALER',
  paymentInformation: {
    bank: 'Test Bank',
    bic: 'BYLADEM1001',
    iban: 'DE02120300000000202051',
  },
  phone: '+49123456789',
  salesTaxId: 'DE659845785',
  taxNumber: null,
  version: 1,
};

export const MOCK_ORGANIZATION_ADMIN_ROLE_ID = 'roleIdOA';
export const MOCK_ORGANIZATION_USER_ROLES = new BehaviorSubject([{ name: StaticRole.PLATFORM_ADMIN }] as UserRole[]);
export const MOCK_REQUEST_ORG_ID = '63a56f5a704b744a2995513a';
export const MOCK_CARTRIDGE_VARIANT_ID = '63908b0f40aab46a5c4bb46c';
export const MOCK_LEISTUNG_ROLE_NAME = 'Leistung-Prototyp Rolle';

export const MOCK_LEISTUNG_ROLE = {
  name: MOCK_LEISTUNG_ROLE_NAME,
  id: 'role-id',
  leistungId: MOCK_CARTRIDGE_VARIANT_ID,
  localizedDisplayName: MOCK_LEISTUNG_ROLE_NAME,
  organizationId: 'org-id',
} as UserRole;

export const MOCK_ROLE1L1SO1G1: UserRole = {
  id: 'role-id-1-l1-g1',
  name: 'role-name-1-l1-g1',
  organizationId: 'org-id',
  suborganizationId: 'sub-org-id-1',
  leistungId: 'leistung-id-1',
  groupId: 'group-id-1',
  localizedDisplayName: 'localized-display-name-1-l1-g1-en',
  localizedDescription: 'localized-description-1-l1-g1-en',
  localizedCartridgeName: 'localized-cartridge-name-1-en',
};

export const MOCK_ROLE1L1SO2G1: UserRole = {
  id: 'role-id-1-l1-g1',
  name: 'role-name-1-l1-g1',
  organizationId: 'org-id',
  suborganizationId: 'sub-org-id-2',
  leistungId: 'leistung-id-1',
  groupId: 'group-id-1',
  localizedDisplayName: 'localized-display-name-1-l1-g1-en',
  localizedDescription: 'localized-description-1-l1-g1-en',
  localizedCartridgeName: 'localized-cartridge-name-1-en',
};

export const MOCK_ROLE2L1SO1G1: UserRole = {
  id: 'role-id-2-l1-g1',
  name: 'role-name-2-l1-g1',
  organizationId: 'org-id',
  suborganizationId: 'sub-org-id-1',
  leistungId: 'leistung-id-1',
  groupId: 'group-id-1',
  localizedDisplayName: 'localized-display-name-2-l1-g1-en',
  localizedDescription: 'localized-description-2-l1-g1-en',
  localizedCartridgeName: 'localized-cartridge-name-1-en',
};

export const MOCK_ROLE1L2G1: UserRole = {
  id: 'role-id-1-l2-g1',
  name: 'role-name-1-l2-g1',
  organizationId: 'org-id',
  suborganizationId: 'sub-org-id',
  leistungId: 'leistung-id-2',
  groupId: 'group-id-1',
  localizedDisplayName: 'localized-display-name-1-l2-g1-en',
  localizedDescription: 'localized-description-1-l2-g1-en',
  localizedCartridgeName: 'localized-cartridge-name-2-en',
};

export const MOCK_ROLE1L1G2: UserRole = {
  id: 'role-id-1-l1-g2',
  name: 'role-name-1-l1-g2',
  organizationId: 'org-id',
  suborganizationId: 'sub-org-id',
  leistungId: 'leistung-id-1',
  groupId: 'group-id-2',
  localizedDisplayName: 'localized-display-name-1-l1-g2-en',
  localizedDescription: 'localized-description-1-l1-g2-en',
  localizedCartridgeName: 'localized-cartridge-name-1-en',
};

export const MOCK_USAGE_RIGHTS = {
  result: [
    {
      id: '63c69a09c0734212c9837203',
      organizationId: '63a56f5a704b744a2995513a',
      cartridgeVariantId: MOCK_CARTRIDGE_VARIANT_ID,
      cartridgeName: 'Leistung-Prototyp',
      cartridgeVariantName: 'Variante 1',
      state: UsageRightState.BOOKED,
      boughtAt: new Date('2023-01-17T12:52:25.213Z'),
      validityPeriodStart: new Date('2023-01-17T12:52:25.213Z'),
      validityPeriodEnd: new Date('2023-01-17T12:58:25.213Z'),
      paymentModel: UsageRightPaymentModel.FIXED_PRICE,
    },
    {
      id: '63c69a09c0734212c9837204',
      organizationId: '63a56f5a704b744a2995513a',
      cartridgeVariantId: '63908b0f40aab46a5c4bb46e',
      cartridgeName: 'Leistung-Prototyp 2',
      cartridgeVariantName: 'Variante 1',
      state: UsageRightState.BOOKED,
      boughtAt: new Date('2023-01-17T12:52:25.213Z'),
      validityPeriodStart: new Date('2023-01-17T12:52:25.213Z'),
      validityPeriodEnd: new Date('2023-01-17T12:58:25.213Z'),
      paymentModel: UsageRightPaymentModel.FIXED_PRICE,
    },
  ],
  pageIndex: 0,
  pageSize: 10,
  totalCount: 1,
  hasNext: false,
} as Page<UsageRight>;

export const MOCK_ORGANIZATION_USER = {
  salutation: 'm',
  phone: '123456789',
  firstname: 'Max',
  lastname: 'Muster',
  language: 'de-de',
  email: 'max.muster@dto.de',
  address: {
    city: 'Berlin',
    countryCode: 'DE',
    zipCode: '10000',
    street: 'Teststraße',
    streetNumber: '123',
  },
  roles: [StaticRole.ORGANIZATION_MEMBER],
  platformRoles: [StaticRole.ORGANIZATION_MEMBER],
  userOrganizationStatus: UserOrganizationStatus.ACTIVE,
} as OrganizationUserDTO;

export const MOCK_ORGANIZATION_USER_WITH_ACTIVE_MEMBERSHIP = {
  ...MOCK_ORGANIZATION_USER,
  activeOrganizationMemberships: true,
};

export const MOCK_MEMBERSHIP_ORIGIN = {
  createdByFullName: 'John Doe',
  createdByIsActiveInOrganization: true,
  becameActiveAt: new Date('2023-04-25T11:26:50.601Z'),
  createdAt: new Date('2023-04-25T11:26:50.601Z'),
  originatedFrom: 'INVITATION',
};

export const MOCK_DEMO_USER = {
  firstname: 'Max',
  lastname: 'Mustermann',
} as OrganizationUserDTO;

export const MOCK_DEMO_USAGE_RIGHTS = [{ cartridgeVariantId: 'demo-cartridge-id-1' }] as UsageRight[];

export const MOCK_CARTRIDGE_ROLE_ASSIGNMENTS = new Map([
  ['demo-cartridge-id-1', [{ localizedDisplayName: '' }] as UserRole[]],
]);

export const MOCK_USER_GROUPS = [{ id: 'demoGroupId1', displayName: 'Einkauf' }] as Group[];

export const MOCK_GROUP_ROLES_ASSIGNMENT = {
  demoGroupId1: [
    {
      cartridgeId: 'group-demo-cartridge-id-1',
      localizedCartridgeName: '',
      roles: [
        {
          groupId: 'demoGroupId1',
          localizedDisplayName: '',
        },
      ] as UserRole[],
    },
  ],
};
